<template>
  <div>
    <el-upload
        class="upLoadPicBox"
        ref="directUpload"
        action="#"
        :multiple="limit > 1"
        :limit="limit"
        :show-file-list="false"
        :file-list="uploadedFileList"
        :http-request="uploadRequest"
        :before-upload="beforeUpload"
        :accept="accept"
        :on-exceed="handleExceed"
    >
      <div class="flex-row-h-center img-box">
        <div
            class="upload"
            v-for="(item, index) in uploadedFileList"
            :key="item">
          <div>
            <div
                @click="currentIndex = index"
                :class="['upload-mask', 'upload-mask-bgColor']"
                @mouseenter="hoverIndex = index"
                @mouseleave="hoverIndex = null"
                :style="{ opacity: hoverIndex === index ? 1 : 0 }"
            >
              <i v-if="hoverIndex === index" class="el-icon-delete delete-icon" @click.stop="handleRemove(index)"></i>
            </div>
            <img :src="item.url" class="upload-img" alt=""/>
          </div>
        </div>
        <div class="upload"
             v-if="limit > 1 || (limit === 1 && !uploadedFileList.length)">
          <i class="el-icon-camera cameraIconfont" @click="currentIndex = 'add'"/>
        </div>
      </div>
    </el-upload>
  </div>
</template>

<script>
/**
 * uploadedFileList: 回显数据
 * fileList: 文件列表 ---> [{name: 'food.jpg', url: 'https://xxx.cdn.com/xxx.jpg'}]
 * hoverIndex: --->控制删除图标的显示
 * model: 文件类型 ---> 'img'||'video'
 * limit:文件数量限制
 * isTinymce: 富文本中的直传组件需要传true
 * size: 文件大小 ----'1MB'||'1'(不传单位默认为字节)
 * customFileType: 文件指定格式限制 ---> "['image/png','image/jpeg']"
 */
import {directFileFn, getDirectInfo, beforeUpload} from '@/utils/directFile';

export default {
  name: 'directUpload',
  props: {
    model: {type: String, default: ''},
    limit: {type: Number, default: 0},
    isTinymce: {type: Boolean, default: false},
    fileList: {type: Array, default: () => []},
    size: {type: String, default: ''},
    customFileType: {type: Array, default: () => []},
  },
  data() {
    return {
      uploadedFileList: [],
      fileTypeMaps: {
        img: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
        video: ['video/mp4'],
        default: ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'video/mp4'],
      },
      hoverIndex: null, // 控制当前图片的删除图标的显示
      accept: null, // 文件类型
      currentIndex: 'add', // 索引or新增
      allowTypes: [], //允许通过的类型
    };
  },
  watch: {
    fileList: {
      handler(newVal) {
        this.uploadedFileList = newVal.map(item => {
          return {
            name: item,
            url: item
          }
        })
        this.hoverIndex = null;
      },
      immediate: true,
      deep: true,
    },
    model: {
      handler(newVal) {
        const types = this.fileTypeMaps[newVal] || this.fileTypeMaps.default;
        this.allowTypes = types;
        this.accept = types.join(',');
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    beforeUpload(file) {
      return beforeUpload(file, this.customFileType, this.allowTypes, this.size);
    },
    async uploadRequest({file}) {
      //sts临时身份是否到了过期时间
      const stsItem = JSON.parse(localStorage.getItem('stsItem'));
      if (!(stsItem && stsItem.expirationTime > Date.now())) await getDirectInfo();

      try {
        const getFilePath = await directFileFn(file);
        this.hoverIndex = null; // 隐藏删除图标
        const newItem = {
          name: getFilePath.url,
          url: getFilePath.url
        };
        //如果是富文本需要直接赋值，不然上传两张图片第一张会出现两次
        if (this.isTinymce) {
          this.uploadedFileList = newItem;
        } else {
          if (this.currentIndex === 'add') {
            this.uploadedFileList.push(newItem);
          } else {
            this.uploadedFileList.splice(this.currentIndex, 1, newItem);
          }
        }
        const urlList = this.uploadedFileList.map(item => item.url)
        this.$emit('update:fileList', urlList);
        this.$emit('clearValid');
        this.currentIndex = 'add';
      } catch (err) {
        console.log('捕获到错误:', err);
        this.$message.error('上传失败,请重新上传');
      }
    },
    handleExceed(files, fileList) {
      if (fileList.length >= this.limit && this.currentIndex === 'add') {
        return this.$message.warning(`当前限制选择 ${this.limit} 个文件，共选择了 ${fileList.length} 个文件`);
      }
      const isValid = this.beforeUpload(files[0]);
      if (!isValid) return false;

      this.$refs.directUpload.handleStart(files[0]); // 开始处理新的文件
      this.$refs.directUpload.submit(); // 手动上传
    },
    handleRemove(index) {
      this.uploadedFileList.splice(index, 1);
      this.hoverIndex = null;
      const urlList = this.uploadedFileList.map(item => item.url)
      this.$emit('update:fileList', urlList);
    },
  },
};
</script>
<style lang="scss" scoped>
.upload {
  margin: 2px;
  height: 85px;
  position: relative;
}

.upload-img {
  width: 80px;
  height: 85px;
  object-fit: cover;
}

.closeIcon {
  position: absolute;
  right: -5px;
  top: 0;
  cursor: pointer;
}

.upLoadPicBox .upload {
  width: 80px;
  height: 85px;
  line-height: 58px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.02);
  display: flex;
  justify-content: center;
  align-items: center;
}

.upload-mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.upload-mask-bgColor {
  background-color: rgba(0, 0, 0, 0.5);
}

.delete-icon {
  font-size: 20px;
  cursor: pointer;
}

.img-box {
  flex-wrap: wrap;
}

</style>
